import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export default function ResetPasswordDialog({ account }) {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      await api.post(`/admin/users/members/${account.id}/reset-password`, { password });
      toast.success("Password member berhasil direset");
      setOpen(false); setPassword("");
    } catch (error) { toast.error(formatApiErrorDetail(error.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return <Dialog open={open} onOpenChange={(value) => { if (!saving) { setOpen(value); setPassword(""); } }}>
    <DialogTrigger asChild><Button variant="outline" size="sm" className="rounded-none">Reset Password</Button></DialogTrigger>
    <DialogContent className="rounded-none">
      <DialogHeader><DialogTitle>Reset Password Member</DialogTitle><DialogDescription>Password akun {account.name} akan diganti dengan password baru yang Anda masukkan.</DialogDescription></DialogHeader>
      <form onSubmit={submit} className="space-y-4">
        <label className="block text-sm">Password baru<Input required minLength={8} type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} /></label>
        <Button disabled={saving} type="submit">{saving ? "Menyimpan..." : "Reset Password"}</Button>
      </form>
    </DialogContent>
  </Dialog>;
}
